import { IDocumentItemKey } from "./IDocumentItemKey";

export interface IDocumentItemSpecifiable {
  itemKey: IDocumentItemKey;
}

export function instanceOfIDocumentItemSpecifiable(instance: any): instance is IDocumentItemSpecifiable {
  return instance
      && (instance.itemKey !== undefined);
}
